module.exports = __webpack_public_path__ + "img/arrow-left.132fce38.svg";